module.exports = "<div class=\"row-fluid\">\r\n    <div class=\"list span6\"></div>\r\n    <div class=\"selected span6\"></div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/video/videoPageView.html
 ** module id = 24
 ** module chunks = 0
 **/